import { Route, Routes } from 'react-router-dom';
import AccessRight from './components/AccessRight';
import FormAccessRight from './components/FormAccessRight';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';

export function AccessRightRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.ACCESS_RIGHTS) && (
                <>
                    <Route index element={<AccessRight />} />
                    <Route path="form/:id?" element={<FormAccessRight />} />
                </>
            )}
        </Routes>
    );
}
